<div class="h-full bg-white overflow-hidden relative">
  <div class="h-full overflow-y-auto">

    <!-- Action Bar -->
    <div class="flex items-center gap-2.5 py-4 px-7 border-b border-[var(--app-base)] flex-wrap">
      <!-- Left buttons -->
      <button (click)="backToRecommendations()"
        class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">arrow_back</span> BACK
      </button>

      <button (click)="openDeleteDraftDialog()"
        class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--notification-error)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">delete</span> DELETE DRAFT
      </button>

      <button (click)="saveRecommendationDraft()"
        class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
        SAVE DRAFT
      </button>

      <!-- Downloads Dropdown -->
      <div class="relative" #downloadsDropdown>
        <button (click)="showDownloadsMenu = !showDownloadsMenu; $event.stopPropagation()"
          class="py-1.5 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-[12px] font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
          <span class="material-icons text-[16px]">download</span> DOWNLOADS
          <span class="material-icons text-[16px]">expand_more</span>
        </button>
        <div *ngIf="showDownloadsMenu"
          class="absolute top-[calc(100%+4px)] left-0 min-w-[150px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
          <div (click)="downloadSoftTissueReport(); showDownloadsMenu = false"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Leaf Report</div>
          <div (click)="downloadVitaReport(); showDownloadsMenu = false"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">Vita Report</div>
        </div>
      </div>

      <div class="flex-1"></div>
    </div>

    <!-- Content -->
    <app-leaf-recommendation (emitSearch)="searchText = $event; searchRecommendations()" (emitPaginateChange)="onPaginateChange($event)" (noteChangeEmit)="note = $event.note;comment = $event.comment" [note]="note" [comment]="comment"></app-leaf-recommendation>

  </div>
</div>
